import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Change,
  Reset,
} from "../../../store/async-actions/digitalmarketing/header";
import { GetcustomerList } from "../../../store/async-actions/digitalmarketing/dashboard";
import { getDashboard } from "../../../Service/api/ApiUrls";
import axios from "../../../Service/axios";
import {
  useGetDashboardCustomersQuery,
  useGetDashboardHealthIssuessQuery,
  useGetDashboardStatusesQuery,
} from "../../../Service/dashboard";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import DashTable from "./DashTable";
import DashTabs from "./DashTabs";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import DateRangePicker from "../../../Component/DigitalMarketing/Forms/DateRangePicker";
import Dropdown from "../../../Component/DigitalMarketing/Forms/Dropdown";
import { Button } from "@mui/material";
import moment from "moment";
import { Source } from "../Reports/Utils/TableHeadlist";
import { FiFilter } from "react-icons/fi";
import DialogModal from "../../../Component/DigitalMarketing/DialogModal";
import { LeadBulkuploadForm } from "./Utils/TableHeadlist";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import { useAddBulkCustomerMutation } from "../../../Service/customers";
import StageDetails from "./MedicineDetails";
import PermissionCheck from "../../../Component/PermissionCheck";
import { useGetIVFJourneysQuery } from "../../../Service/ivfJourneyStage";
import { useGetMedicineMastersQuery } from "../../../Service/MedicineMaster";
import MedicineDetails from "./MedicineDetails";
import { useGetCustomerJourneyMastersQuery } from "../../../Service/CustomerJourneyMaster";
import { useGetAllBranchesQuery } from "../../../Service/Masters";
import Loader from "../../../Component/DigitalMarketing/Loader";
export const initialMedicine = {
  activeStatus: 1,
  customerJourneyName: "",
  description: "",
};
function CustomerJourney() {
  const [pagination, setpagination] = useState(1);
  const [lead, setLeads] = useState<any>({});
  const [filter, setFilter] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [show, setshow] = useState(false);
  const [Show, setShow] = useState(false);
  const [filteredValues, setFilteredValues] = useState(null);

  const initialstate = {
    startDate: null,
    endDate: null,
  };

  const [date, setDate] = useState(initialstate);
  const [dateRange, setDateRange] = useState(initialstate);
  const [created, setCreated] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [updated, setUpdated] = useState(false);
  const [source, setSource] = useState("");
  const dispatch = useDispatch<any>();
  const [medicine, setMedicine] = useState(initialMedicine);

  const getStatus = useGetDashboardStatusesQuery();
  const [open, setOpen] = useState(false);
  const { open: open1, message, openSnackBar, type } = useSnackbar();

  const handleOpen = () => {
    setOpen(true);
  };
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };
  const {
    data: customerJourneyData,
    isLoading,
    refetch,
  } = useGetCustomerJourneyMastersQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
  const { data: branchOptions } = useGetAllBranchesQuery({
    refetchOnMountOrArgChange: true,
  });
  const handleClose = () => {
    setOpen(false);
    setLeads({});
  };
  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    setpagination(1);
    refetch();
  }, [filter, searchValue]);
  useEffect(() => {
    // console.log("created 11111111");
    if (created === true) {
      openSnackBar("Added successfully");

      setTimeout(() => {
        // console.log("created 222222");

        refetch();
        setCreated(false);
      }, 1000);
    }
  }, [created]);
  useEffect(() => {
    // console.log("updated 11111111");
    if (updated === true) {
      openSnackBar("Updated successfully");

      setTimeout(() => {
        //  console.log("updated 222222");

        refetch();
        setUpdated(false);
      }, 1000);
    }
  }, [updated]);
  useEffect(() => {
    // console.log("updated 11111111");
    if (deleted === true) {
      openSnackBar("Deleted successfully", "error");

      setTimeout(() => {
        //  console.log("updated 222222");

        refetch();
        setDeleted(false);
      }, 1000);
    }
  }, [deleted]);

  const [addBulkCustomer] = useAddBulkCustomerMutation();

  useEffect(() => {
    dispatch(Reset());
  }, [dispatch]);

  const onFilter = (value) => {
    if (value === "All") {
      setFilter("");
    } else {
      setFilter(value);
    }
  };
  useEffect(() => {
    const data: any = {
      first: "Customer Journey",
    };
    dispatch(Change(data));
  }, [dispatch]);
  // const onHandleChange = (event) => {
  //   const { name, value } = event.target;
  //   if (name === "date") {
  //     setDate({
  //       startDate: moment(value[0]).format("YYYY-MM-DD"),
  //       endDate: moment(value[1]).format("YYYY-MM-DD"),
  //     });
  //     setDateRange(value);
  //   } else if (name === "source") {
  //     setSource(value);
  //   }
  // };

  const ClearFilter = () => {
    setShow(false);
    setDate(initialstate);
    setDateRange(initialstate);
    // setParamsValue({ date: initialstate, source: "" });
    setSource("");
    setSearchValue("");
  };
  const OnChange = (event) => {
    const { name, value, files } = event.target;
    setLeads((prevState) => ({ ...prevState, [name]: files[0] }));
  };
  const ListFilter = () => {
    if (
      !date?.startDate ||
      date?.startDate === "Invalid date" ||
      date?.endDate !== "Invalid date"
    ) {
      setShow(true);
      setpagination(1);
    } else {
      openSnackBar("Please select end date!", "error");
    }
  };

  const onSubmit = async () => {
    let data: any = {
      ...lead,
    };
    // console.log(data);
    var form_data = new FormData();
    for (var key in data) {
      form_data.append(key, data[key]);
      // console.log(key, data[key]);
    }
    if (lead?.file) {
      try {
        const payload = await addBulkCustomer(form_data).unwrap();
        openSnackBar("Added successfully");
        handleClose();
      } catch (error: any) {
        openSnackBar(error.data.error, "error");
      }
    } else {
      openSnackBar("Please fill all data before submit!", "error");
    }
  };
  if (isLoading) {
    return <Loader loading={true}/>;
  }
  return (
    <React.Fragment>
      <div>
        <Toast open={open1} type={type} message={message} />
        <DialogModal
          title="Upload Leads"
          formlist={LeadBulkuploadForm}
          open={open}
          download={true}
          handleChange={OnChange}
          handleSubmit={onSubmit}
          handleClose={handleClose}
        />
        <Row className="mb-3">
          <Col md={5}>
            <SearchBox
              value={searchValue}
              onChange={(event) => onChangeSearch(event)}
            />
          </Col>
        </Row>
        <Row>
          {/* <Col xs={12} md={12}>
            <DashTabs
              show={show}
              setshow={setshow}
              handleOpen={handleOpen}
              onFilter={onFilter}
              setMedicine={setMedicine}
            />
          </Col> */}
          <Col xs={12} md={12}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <Button
                variant="contained"
                id="btn"
                onClick={() => {
                  setshow(!show);
                }}
              >
                {show ? "x Close" : "+ Add Customer Journey"}{" "}
              </Button>
            </div>
          </Col>
        </Row>

        <div className="grid-container">
          <div className={show ? "item1" : "item1-full"}>
            <DashTable
              pagination={pagination}
              show={show}
              medicines={filteredValues ? filteredValues : customerJourneyData}
              deleted={deleted}
              setDeleted={setDeleted}
              setshow={setshow}
              setMedicine={setMedicine}
              refetch={refetch}
              updated={updated}
              setUpdated={setUpdated}
            />
            {!isLoading && (
              <Pagination
                setpagination={setpagination}
                pagination={pagination}
                data={customerJourneyData}
              />
            )}
          </div>
          {show ? (
            <div className="Customer-details mx-3 item2">
              <ul
                className="md-bord"
                style={{ height: "100%", maxHeight: "100%" }}
              >
                <MedicineDetails
                  medicine={medicine}
                  updated={updated}
                  setUpdated={setUpdated}
                  created={created}
                  setCreated={setCreated}
                  branchOptions={branchOptions}
                  cancel={
                    <Button
                      variant="contained"
                      id="btn-cancel"
                      className="me-2"
                      onClick={() => {
                        setshow(!show);
                        setMedicine(initialMedicine);
                      }}
                    >
                      Cancel
                    </Button>
                  }
                  show={show}
                  setshow={setshow}
                />
              </ul>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default React.memo(CustomerJourney);
